// Subscriber payment history — flat list across all chits.

import type { ReactElement } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { orpc } from '../lib/orpc.js';
import { format_inr } from '../lib/format.js';

interface Payment {
  payment_id: string;
  chit_id: string;
  amount_paise: number;
  method: string;
  reference: string | null;
  timestamp: string;
  due_month: string;
  note: string | null;
}

export function SubHistory(): ReactElement {
  const { t } = useTranslation();
  const q = useQuery({
    queryKey: ['sub-history-all'],
    queryFn: () => orpc.sub.payment_history({ limit: 200 }),
  });

  if (q.isLoading) return <div style={{ color: 'var(--ink-3)', fontSize: 13 }}>Loading…</div>;
  const payments = (q.data?.payments ?? []) as Payment[];

  return (
    <>
      <div className="h-title" style={{ fontSize: 20 }}>{t('sub.history.title', 'All payments')}</div>
      {payments.length === 0 && (
        <div className="card" style={{ padding: 22, textAlign: 'center', color: 'var(--ink-3)', fontSize: 13 }}>
          {t('sub.history.empty', 'No payments recorded yet.')}
        </div>
      )}
      {payments.length > 0 && (
        <div className="card sub-list" style={{ padding: 0 }}>
          {payments.map((p) => (
            <div key={p.payment_id} className="row">
              <div>
                <div className="mono" style={{ fontSize: 13, color: 'var(--good)' }}>+{format_inr(p.amount_paise)}</div>
                <div style={{ fontSize: 11, color: 'var(--ink-3)' }}>
                  {p.due_month} · {p.method.toUpperCase()}{p.reference ? ` · ${p.reference}` : ''}
                </div>
                {p.note && <div style={{ fontSize: 10, color: 'var(--ink-3)', marginTop: 2 }}>{p.note}</div>}
              </div>
              <div style={{ fontSize: 10, color: 'var(--ink-3)' }}>{new Date(p.timestamp).toLocaleDateString()}</div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
